import styled from 'styled-components';
import { LinkButton } from 'components/atoms/button';
import { Menu } from 'components/atoms/dropdown';
import { ButtonWrapper } from 'components/molecules/views/components';
import { Caption01 } from 'components/styles';

export const Wrapper = styled.div`
  width: 100%;
  background-color: var(--white-100);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-04) var(--spacing-07);
  position: sticky;
  top: 0;
  min-height: calc(var(--spacing-09) + var(--spacing-03));
`;

export const NameWrapper = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  flex-direction: column;
`;

export const AttachmentName = styled.h5`
  ${Caption01};
  margin-bottom: 0;
`;

export const TaskNameWrapper = styled(LinkButton)`
  ${Caption01};
  border: none;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeaderButtonWrapper = styled(ButtonWrapper)`
  padding: var(--spacing-01) var(--spacing-03);
  margin: 0 var(--spacing-02);

  margin: 0 var(--spacing-02);
  padding: var(--spacing-01);
  cursor: pointer;
`;

export const ActionsButtonWrapper = styled(ButtonWrapper)`
  padding: var(--spacing-03);
  margin: 0 var(--spacing-02);
  cursor: pointer;
`;

export const ActionButtonActiveWrapper = styled(ButtonWrapper)<{
  active: boolean;
}>`
  padding: var(--spacing-03);
  margin: 0 var(--spacing-02);
  background: ${({ active }) => (active ? 'var(--coolest-gray-20)' : '')};
  cursor: pointer;
`;

export const MenuItem = styled(Menu.Item)`
  display: flex;
  justify-content: space-between;
`;
